import { render, staticRenderFns } from "./CustomerTables.vue?vue&type=template&id=113aa950&scoped=true"
import script from "./CustomerTables.vue?vue&type=script&lang=js"
export * from "./CustomerTables.vue?vue&type=script&lang=js"
import style0 from "./CustomerTables.vue?vue&type=style&index=0&id=113aa950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113aa950",
  null
  
)

export default component.exports